var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text--secondary"},[_vm._v("Load up gift card balance first. You can then customize the cards and message to recipients.")])
}
var staticRenderFns = []

export { render, staticRenderFns }